import React from "react";
import { Typography } from "@material-ui/core";

export default function NoItems(props: { children: React.ReactNode }) {
  return (
    <Typography
      variant="subtitle1"
      align="center"
      style={{ marginTop: "40px" }}
    >
      {props.children}
    </Typography>
  );
}
